export default __webpack_public_path__ + "static/media/SZ.fd71b663.svg";